// extracted by mini-css-extract-plugin
module.exports = {"stats-row":"stats-row_stats-row__jPtz0","tab-stat":"stats-row_tab-stat__tcip3","tab-item":"stats-row_tab-item__iPS4Y"};